<template>
  <v-container grid-list-xl fluid>

    <DimensionSelector v-on:room="setRoom($event)" :valueName="item.name" :valueWidth="item.width" :valueDrop="item.drop" ref="dimensionSelector" @ready="isReady => readyToSubmitDimension = isReady" :type="this.item.type"></DimensionSelector>

    <v-flex xs12>
      <div v-if="$v.item.$error && !$v.item.total.required" class="red--text">Please enter Price</div>
      <div v-if="$v.item.$error && !$v.item.total.decimal" class="red--text">Please enter correct price</div>
      <v-text-field label="Price" v-model="item.total"></v-text-field>
    </v-flex>
    <v-textarea name="notes" label="Line Item Notes" v-model="item.notes"></v-textarea>
    <v-btn v-if="!edit" @click="addItem()" color="primary">Add Misc Item</v-btn>
    <v-btn v-else @click="addItem()" color="primary">Update {{ item.type }}</v-btn>
  </v-container>
</template>

<script>

import DimensionSelector from '@/components/parts/DimensionSelector'
import { required, decimal } from 'vuelidate/lib/validators'

export default {
  props: {
    edittingItem: {
      default: null
    },
    editChange: {
      default: null
    }
  },
  components: {
    DimensionSelector
  },
  data () {
    return {
      item: {
        type: 'Misc',
        name: null,
        width: null,
        drop: null,
        total: 0,
        orderID: null,
        notes: null
      },
      edit: false,
      readyToSubmitDimension: false
    }
  },
  validations: {
    item: {
      name: { required },
      drop: { required },
      width: { required },
      total: { required, decimal }
    }
  },
  mounted () {
    this.useEdittingItem(this.edittingItem)
  },
  watch: {
    edittingItem (item) {
      this.useEdittingItem(item)
    }
  },
  methods: {
    setRoom (room) {
      this.item.width = room.width
      this.item.drop = room.drop
      this.item.name = room.name
    },
    addItem () {
      this.$refs.dimensionSelector.touch()
      this.$v.item.$touch()
      if (this.$v.item.$pending || this.$v.item.$error || !this.readyToSubmitDimension) return
      this.edit = false
      this.$emit('create-item', this.item)
    },

    useEdittingItem (item) {
      if (!this.editChange) {
        if (item) {
          this.edit = true
          this.item = item
        }
      } else {
        this.item._id = item._id
        this.item.name = item.name
        this.item.width = item.width
        this.item.drop = item.drop
        this.item.orderID = item.orderID
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/products/Misc.vue